type RichTextNode = {
    nodeType: string;
    value?: string;
    content?: RichTextNode[];
};

export const getTextFromRichText = (node: RichTextNode): string => {
    let result = '';

    if (node.nodeType === 'text' && node.value) {
        result += node.value;
    }

    if (Array.isArray(node.content)) {
        node.content.forEach((child, index) => {
            result += getTextFromRichText(child);
            if (
                child.nodeType === 'paragraph' &&
                index < node.content!.length - 1
            ) {
                result += '<br><br>';
            }
        });
    }

    return result;
};
